"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _newComponents = require("./new-components");
var _constants = require("./constants");
var _envConstants = require("./env-constants");
var _currency = require("./currency");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var TermsCheckbox = function TermsCheckbox(_ref) {
  var toggleTermsAgreed = _ref.toggleTermsAgreed,
    termsAgreed = _ref.termsAgreed,
    product = _ref.product,
    baseUrl = _ref.baseUrl,
    girls = _ref.girls,
    guys = _ref.guys,
    minAge = _ref.minAge,
    id = _ref.id,
    travelTermsCheckboxId = _ref.travelTermsCheckboxId,
    cardChargeCheckboxId = _ref.cardChargeCheckboxId,
    companyId = _ref.companyId,
    weekTerms = _ref.weekTerms,
    destinationId = _ref.destinationId,
    scheduledPayments = _ref.scheduledPayments,
    isScheduledPaymentsUpdate = _ref.isScheduledPaymentsUpdate,
    travelInsuranceCheckBox = _ref.travelInsuranceCheckBox,
    travelTermsAgreed = _ref.travelTermsAgreed,
    toggleTravelTermsAgreed = _ref.toggleTravelTermsAgreed,
    isBookingUkBased = _ref.isBookingUkBased,
    cardCharge = _ref.cardCharge,
    cardChargeAmount = _ref.cardChargeAmount,
    cardChargeAgreed = _ref.cardChargeAgreed,
    toggleCardChargeAgreed = _ref.toggleCardChargeAgreed,
    currency = _ref.currency,
    cardScheme = _ref.cardScheme,
    cardType = _ref.cardType;
  var isYachtsAndFriends = _constants.COMPANIES.YNF === parseInt(companyId, 10);
  var isCroatiaNamaste = _constants.TYW_DESTINATION.CROATIA_NAMASTE === destinationId;
  var isTyw = _envConstants.ENV.SITE === 'tyw';
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_newComponents.CheckBox, {
    id: id,
    className: "margin-y-md",
    onChange: toggleTermsAgreed,
    checked: termsAgreed,
    label: /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, "I agree to the general ", product, "\u2019s", ' ', /*#__PURE__*/_react["default"].createElement("a", {
      className: "d8-u-color-secondary",
      href: "".concat(baseUrl, "/terms-and-conditions").concat(companyId ? "?companyId=".concat(companyId) : ''),
      target: "_blank"
    }, "Terms and Conditions"), isTyw && !isYachtsAndFriends && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, ' ', "and of the ", ' ', /*#__PURE__*/_react["default"].createElement("a", {
      className: "d8-u-color-secondary",
      href: "".concat(baseUrl, "/agent-terms-and-conditions?companyId=").concat(companyId, "&country=").concat(isBookingUkBased && 'GB'),
      target: "_blank"
    }, "Terms and Conditions"), ' ', " of the agent Day8 Experiences Ltd"), weekTerms && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, ' ', "and the route ", ' ', /*#__PURE__*/_react["default"].createElement("a", {
      className: "d8-u-color-secondary",
      href: weekTerms,
      target: "_blank"
    }, "Terms and Conditions")), !isYachtsAndFriends && !isCroatiaNamaste && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, (girls || guys) && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, ' ', "- my ratio is ", girls, " and ", guys), minAge && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, ' ', "and all my crew will be aged ", minAge, " or over during the event"), "."), scheduledPayments && !!scheduledPayments.length && /*#__PURE__*/_react["default"].createElement("span", null, ' ', "I agree that future payments can be debited from my chosen method of payment on a recurring basis automatically until the balance has been paid."), isScheduledPaymentsUpdate && /*#__PURE__*/_react["default"].createElement("span", null, ' ', "I agree that an initial charge of \u20AC1 can be debited from my chosen payment method, which will then be removed from the remaining upcoming payments."))
  }), travelInsuranceCheckBox && /*#__PURE__*/_react["default"].createElement(_newComponents.CheckBox, {
    id: travelTermsCheckboxId,
    className: "margin-y-md",
    checked: travelTermsAgreed,
    onChange: toggleTravelTermsAgreed,
    label: /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, "I will ensure that I ", girls + guys > 1 && "and ".concat(product !== 'The Ski Week' ? 'all my crew members' : 'everyone I am booking for'), " have fully comprehensive travel insurance for a trip of this type. ", product, " strongly recommends that your policy also covers any travel disruption related to COVID-19")
  }), cardChargeAmount > 0 && /*#__PURE__*/_react["default"].createElement(_newComponents.CheckBox, {
    id: cardChargeCheckboxId,
    className: "margin-y-md",
    checked: cardChargeAgreed,
    onChange: toggleCardChargeAgreed,
    label: /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, "I understand and agree to pay the ", /*#__PURE__*/_react["default"].createElement(_currency.FormatCurrency, {
      round: false,
      amount: cardChargeAmount / 100,
      baseCurrency: currency,
      showCurrency: currency
    }), " card transaction fee. We impose a surcharge on ", cardScheme, " ", cardType, " card of ", cardCharge, "% to cover our costs of accepting your card payment.", scheduledPayments && !!scheduledPayments.length || isScheduledPaymentsUpdate && ' '.concat(" I agree that future payments will be charged with the same fee of ", cardCharge, "% until the balance has been paid."))
  }));
};
TermsCheckbox.propTypes = {
  id: _propTypes["default"].string.isRequired,
  travelTermsCheckboxId: _propTypes["default"].string.isRequired,
  cardChargeCheckboxId: _propTypes["default"].string.isRequired,
  product: _propTypes["default"].string.isRequired,
  toggleTermsAgreed: _propTypes["default"].func.isRequired,
  termsAgreed: _propTypes["default"].bool.isRequired,
  girls: _propTypes["default"].string,
  guys: _propTypes["default"].string,
  baseUrl: _propTypes["default"].string.isRequired,
  minAge: _propTypes["default"].number,
  companyId: _propTypes["default"].number,
  weekTerms: _propTypes["default"].string,
  destinationId: _propTypes["default"].number,
  scheduledPayments: _propTypes["default"].array,
  isScheduledPaymentsUpdate: _propTypes["default"].bool,
  travelInsuranceCheckBox: _propTypes["default"].bool,
  travelTermsAgreed: _propTypes["default"].bool,
  toggleTravelTermsAgreed: _propTypes["default"].func,
  isBookingUkBased: _propTypes["default"].bool,
  cardCharge: _propTypes["default"].number,
  cardChargeAmount: _propTypes["default"].number,
  cardChargeAgreed: _propTypes["default"].bool,
  toggleCardChargeAgreed: _propTypes["default"].func,
  currency: _propTypes["default"].string,
  cardType: _propTypes["default"].string,
  cardScheme: _propTypes["default"].string
};
var _default = exports["default"] = TermsCheckbox;